import { createGlobalStyle } from 'styled-components';
import { customGradients } from './theme';

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body {
    width: 100%;
    height: 100%;
  }

  body {
    background: linear-gradient(135deg, rgba(41, 198, 243, 0.1) 0%, rgba(23, 207, 119, 0.1) 100%);
    background-attachment: fixed;
    font-family: 'Inter var', 'Inter', sans-serif;
    color: #1f2937;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .glass-effect {
    background: rgba(255, 255, 255, 0.8) !important;
    backdrop-filter: blur(15px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.05);
  }

  .gradient-text {
    background: ${customGradients.primary} !important;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .gradient-text-secondary {
    background: ${customGradients.secondary} !important;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  @keyframes float {
    0%, 100% {
      transform: translateY(0) rotate(0deg);
    }
    25% {
      transform: translateY(-8px) rotate(-1deg);
    }
    75% {
      transform: translateY(-12px) rotate(1deg);
    }
  }

  @keyframes pulse {
    0% {
      transform: scale(1);
      opacity: 1;
      box-shadow: 0 0 0 0 rgba(0, 104, 185, 0.2);
    }
    50% {
      transform: scale(1.05);
      opacity: 0.9;
      box-shadow: 0 0 0 10px rgba(0, 104, 185, 0);
    }
    100% {
      transform: scale(1);
      opacity: 1;
      box-shadow: 0 0 0 0 rgba(0, 104, 185, 0);
    }
  }

  @keyframes slideUp {
    from {
      transform: translateY(30px);
      opacity: 0;
      filter: blur(5px);
    }
    to {
      transform: translateY(0);
      opacity: 1;
      filter: blur(0);
    }
  }

  .animate-float {
    animation: float 8s ease-in-out infinite;
  }

  .animate-pulse {
    animation: pulse 4s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  }

  .animate-slideUp {
    animation: slideUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  }

  .stagger-children > * {
    opacity: 0;
    animation: slideUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  }

  .stagger-children > *:nth-child(1) { animation-delay: 0.1s; }
  .stagger-children > *:nth-child(2) { animation-delay: 0.2s; }
  .stagger-children > *:nth-child(3) { animation-delay: 0.3s; }
  .stagger-children > *:nth-child(4) { animation-delay: 0.4s; }
  .stagger-children > *:nth-child(5) { animation-delay: 0.5s; }

  /* Ionic overrides */
  ion-content {
    --background: transparent;
  }

  ion-item {
    --background: rgba(255, 255, 255, 0.8);
    --border-radius: 16px;
    margin-bottom: 10px;
    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
    &:hover {
      --background: rgba(255, 255, 255, 0.95);
      transform: translateY(-3px);
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
    }
  }

  ion-card {
    background: rgba(255, 255, 255, 0.85);
    border-radius: 20px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);
    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 15px 35px rgba(0, 0, 0, 0.08);
    }
  }

  ion-button {
    --border-radius: 16px;
    --background: ${customGradients.primary};
    --background-hover: ${customGradients.primary};
    --background-activated: ${customGradients.primary};
    --box-shadow: 0 8px 20px rgba(0, 104, 185, 0.25);
    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
    &:hover {
      transform: translateY(-3px);
      --box-shadow: 0 12px 28px rgba(0, 104, 185, 0.35);
    }
  }
`;

export default GlobalStyles;
